import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9e00e910")
const _hoisted_1 = ["cx", "cy", "fill", "r", "stroke", "stroke-width"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("circle", {
    cx: _ctx.point.x,
    cy: _ctx.point.y,
    fill: _ctx.point.fill,
    r: _ctx.circleRadius,
    stroke: _ctx.point.stroke,
    "stroke-width": _ctx.circleMargin,
    class: "trinket-grid-point",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, null, 8, _hoisted_1))
}